/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Button } from "reactstrap";

const LayoutFormButton = ({
  className,
  text,
  icon,
  outline,
  style={},
  disabled = false,
  onClick
}) => {
  return (
    <Button
      className={className}
      size="sm"
      outline={outline}
      disabled={disabled}
      onClick={onClick}
      style={{ flex: "1", width: "100%", height: "36px", ...style }}
    >
      {icon && (
        <i
          className={`icon bi bi-${icon} d-flex justify-content-center`}
          style={{ fontSize: "1.1rem" }}
        />
      )}
      {!icon && text}
    </Button>
  );
};

export default LayoutFormButton;
